<template>
    <v-layout class="sistema-template">
        <v-navigation-drawer v-model="drawer_open" fixed app :width="220" class="navigation pt-2" :style="{ display: 'flex', flexDirection: 'column', zIndex: zIndex }">
            <a class="toggle-visibility" @click="drawer_open = !drawer_open" v-if="!permiteExibirMenuSuperior || (drawer_open && !$vuetify.breakpoint.lgAndUp)">
                <v-icon :class="{ rotate180: drawer_open }">chevron_right</v-icon>
            </a>
            <img class="logo-menu" :src="logo" alt="Logo Menu" />
            <v-divider class="mb-3" style="border: 1px solid lightgrey" />
            <v-skeleton-loader type="list-item" v-if="carregandoNomeFlavor"></v-skeleton-loader>
            <div v-else-if="flavorExibicao.nomeExibicao" class="font-weight-bold text--dark text-center mb-3">
                {{ flavorExibicao.nomeExibicao }}
            </div>
            <div class="ml-5">
                <div v-for="(item, index) in itemHieraquiaSession" :key="index">
                    <v-row class="mt-1">
                        <v-col cols="2" class="d-flex align-start justify-center">
                            <v-icon style="margin-top: 2px">{{ item.icon }}</v-icon>
                        </v-col>
                        <v-col cols="10" style="word-break: break-word;">
                            <h5 class="text-xs">{{ item.name || "(Sem GN Definido)" }}</h5>
                            <p>
                                <v-tooltip bottom v-if="item.helper">
                                    <template v-slot:activator="{ on }">
                                        <v-icon size="15" v-on="on" class="mr-1" color="primary">
                                            {{ item.helper.icon }}
                                        </v-icon>
                                    </template>
                                    <span>{{ item.helper.text }}</span>
                                </v-tooltip>
                                <span :class="item.isClickable ? 'clickable text-xs' : null" @click="item.isClickable ? acessar(item) : null">{{ item.label }}: {{ item.value }}</span>
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-flex v-if="is_tribanco" text-center pa-2 ma-0 class="titulo dark--text"> ID Tribanco: {{ id_tribanco }} </v-flex>
            <v-divider class="mb-2" style="border: 1px solid lightgrey" />
            <v-list class="pt-0 white">
                <v-list-item :key="i" v-for="(item, i) in menu" class="icon_menu" :class="{ selected: item.selected, 'blocked-item': item.blocked }" @click="acessar(item)">
                    <v-list-item-action>
                        <v-icon size="20" class="mr-2">{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <span>{{ item.text }}</span>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <div style="margin-top: auto" class="text-center dark--text font-subtitle-1 font-weight-bold">
                        {{ appVersion }}
                    </div>
                </div>
            </template>
        </v-navigation-drawer>
        <v-content class="app-content">
            <BarraSuperior v-model="drawer_open" :nome="nome" v-if="permiteExibirMenuSuperior" @logout="logout" />
            <router-view class="router-view" :key="$route.path"></router-view>
        </v-content>
        <DialogEmpresas v-model="dialog_empresas" placeholder="Selecione a empresa" :items="empresas" :show-close-button="!dialog_empresas" @select="escolherEmpresaVendaBackoffice" />
        <Dialog :value="dialog_comissionados" :title="'Selecione um comissionado'" width="350" :show-close-button="false">
            <m-form ref="form" class="pt-4" @submit.prevent="alterarComissionado(null, true)">
                <Autocomplete label="Comissionado:" :items="comissionados" v-model="id_comissionado_usuario_comum_autocomplete" :item-text="descricaoComissionados" item-value="ID_Comissionado" maxlength="100" placeholder="Selecione o comissionado" />
            </m-form>
            <v-layout slot="buttons">
                <v-flex>
                    <v-btn class="btn-default" color="primary" @click="alterarComissionado(null, true)">
                        Confirmar
                    </v-btn>
                </v-flex>
            </v-layout>
        </Dialog>

        <Dialog :value="exibir_autocomplete_comissionados" :title="'SELECIONE UM COMISSIONADO'" width="350" :show-close-button="false">
            <m-form ref="form" class="pt-4" @submit.prevent="escolherComissionadoBackoffice">
                <Autocomplete label="Comissionado:" :items="comissionados_base_local" v-model="id_comissionado_autocomplete" :item-text="descricaoComissionadosBackOffice" item-value="id_comissionado" maxlength="100" placeholder="Selecione o comissionado" />
            </m-form>
            <v-layout slot="buttons">
                <v-flex>
                    <v-btn class="btn-default" color="primary" @click="escolherComissionadoBackoffice">
                        Confirmar
                    </v-btn>
                </v-flex>
            </v-layout>
        </Dialog>

        <DialogPontosVenda v-model="dialog_pontos_venda" placeholder="Selecione o ponto de venda" :items="pontos_vendas" :show-close-button="false" @select="escolherPontoVenda" />

        <DialogAtualizarSenha />

        <DialogSincronizacao v-model="dialog_sincronizacao" />
        <DialogCommercialHierarchyLogin v-model="dialogCommercialHierarchyVisible" :items="hierarquia_comercial" :logando="false" @pontosVendaCarregados="atualizarPontosVenda" />
        <DialogEstruturaComercial v-model="dialogEstruturaComercial" :is-entrando-fluxo-venda="entrando_fluxo_venda" @setarEntrandoFluxoVenda="setarEntrandoVenda" @voltarFluxoVenda="entrarFluxoVendasHierarquiaComercial()" :gerente-negocio="getGerenteNegocioSelecionado()" :estrutura-do-gn-selecionado="getEstruturaDoGNSelecionado()" @pontosVendaCarregados="atualizarPontosVenda" />
        <DialogSalesPointHierarchy v-model="dialogSalesPointHierarchyVisible" :is-entrando-fluxo-venda="entrando_fluxo_venda" @setarEntrandoFluxoVenda="setarEntrandoVenda" @voltarFluxoVenda="entrarFluxoVendasHierarquiaComercial()" :gerente-negocio="getGerenteNegocioSelecionado()" :estrutura-selecionada="getEstruturaComercialSelecionado()" @pontoVendaConfirmado="selecionarPontoVenda" />
        <DialogComissionedHierarchy v-model="dialogComissionedHierarchyVisible" :is-entrando-fluxo-venda="entrando_fluxo_venda" @setarEntrandoFluxoVenda="setarEntrandoVenda" @voltarFluxoVenda="entrarFluxoVendasHierarquiaComercial()" :comissionados="comissionados" />
        <DialogEscolhaAmbienteHierarchy v-model="modalEscolherAmbienteFluxoVendas" :rota="indo_para_rota" :is-entrando-fluxo-venda="entrando_fluxo_venda" @setarEntrandoFluxoVenda="setarEntrandoVenda" :ambientes="ambientes_comissionado" />
        <DialogAtualizacaoDaVersao v-model="dialogAtualizacaoVersao" />
    </v-layout>
</template>

<script>
  import { flavorRes, loadFlavor } from '../plugins/flavors'
  import { alert, existHierarchy, notification } from '../plugins/helpers'
  import { mapMutations, mapState } from 'vuex'
  import DialogAtualizarSenha from '../dialogs/DialogAtualizarSenha'
  import DialogSincronizacao from '../dialogs/DialogSincronizacao'
  import DialogEscolhaAmbienteHierarchy from '../components/hierarquia-comercial/DialogEscolhaAmbienteHierarchy'
  import DialogEmpresas from '../dialogs/DialogEmpresas'
  import DialogPontosVenda from '../dialogs/DialogPontosVenda'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import comissionadosBackOffice from '../mixins/comissionadosBackOffice'
  import startSellToCommercialHierarchy from '../mixins/CommercialHierarchy/startSellToCommercialHierarchy'
  import { CommercialHierarchyTypes, Flavors, FlavorsSemBarraSuperior } from '@/plugins/constants'
  import DialogCommercialHierarchyLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyLogin.vue'
  import DialogEstruturaComercial from '@/components/hierarquia-comercial/DialogEstruturaComercial.vue'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import DialogSalesPointHierarchy from '@/components/hierarquia-comercial/DialogSalesPointHierarchy.vue'
  import DialogComissionedHierarchy from '@/components/hierarquia-comercial/DialogComissionedHierarchy.vue'
  import BarraSuperior from '../components/sistema/BarraSuperior.vue'
  import { AlertTypes } from '../plugins/alerts_types'
  import { mensagemUsuarioBloqueado } from '../enums/usuario_bloqueado/mensagemUsuarioBloqueado'
  import pontosVendaMixin from '../mixins/CommercialHierarchy/pontosVendaMixin'
  import DialogAtualizacaoDaVersao from '../dialogs/atualizacao/DialogAtualizacaoDaVersao.vue'

  export default {
    name: 'Sistema',
    components: {
      DialogEstruturaComercial,
      DialogSincronizacao,
      DialogAtualizarSenha,
      DialogEmpresas,
      DialogPontosVenda,
      DialogCommercialHierarchyLogin,
      DialogSalesPointHierarchy,
      DialogComissionedHierarchy,
      DialogEscolhaAmbienteHierarchy,
      BarraSuperior,
      DialogAtualizacaoDaVersao
    },
    mixins: [comissionadosBackOffice, commercialHierarchy, startSellToCommercialHierarchy, pontosVendaMixin],
    data: () => ({
      appVersion: process.env.VUE_APP_VERSION,
      is_tribanco: false,
      id_tribanco: 'Vice',
      comissionados_base_local: [],
      drawer: true,
      logo: '',
      nome_comissionado: '',
      codigo_comissionado: '',
      dialog_comissionados: false,
      dialog_sincronizacao: false,
      dialog_empresas: false,
      exibir_autocomplete_comissionados: false,
      dialog_pontos_venda: false,
      pontos_vendas: [],
      id_comissionado_autocomplete: '',
      id_comissionado_usuario_comum_autocomplete: '',
      flavors_config: [],
      dialogCommercialHierarchyVisible: false,
      dialogSalesPointHierarchyVisible: false,
      dialogEstruturaComercial: false,
      dialogComissionedHierarchyVisible: false,
      dialogAtualizacaoVersao: false,
      carregandoNomeFlavor: false,
      pontosVenda: [],
      pontosVendaCarregados: false,
      flavorExibicao: {
        nomeExibicao: '',
        flavor: ''
      }
    }),
    computed: {
      ...mapState(['nome', 'id_empresa', 'id_comissionado', 'desativar_selecao_comissionado', 'id_comissionado_venda', 'id_unidade_negocio', 'empresas', 'unidades', 'nm_ponto_venda', 'cd_ponto_venda', 'comissionados', 'admin', 'super_admin', 'exibe_politica_vendas', 'exibe_contratos_sistema', 'exibe_reenvio_whatsapp', 'login_backoffice', 'vendas_backoffice', 'sinalMudarIdentidadeVisual', 'flavor']),
      zIndex () {
        return this.$vuetify.breakpoint.smAndDown ? 204 : 201
      },
      exibir_fechar_dialog_comissionados_usuario_comum () {
        return !(this.codigo_comissionado === '')
      },
      permiteExibirMenuSuperior () {
        return !FlavorsSemBarraSuperior.includes(this.flavor)
      },
      drawer_open: {
        get () {
          return this.$vuetify.breakpoint.xlOnly || this.drawer
        },
        set (val) {
          this.drawer = this.$vuetify.breakpoint.xlOnly || val
        }
      },
      pontosReais () {
        return Array.isArray(this.pontosVenda)
          ? this.pontosVenda.filter(pv => String(pv.idPontoVenda) !== 'todos')
          : []
      },
      menu: function () {
        const isUserHierarquia = existHierarchy(this.hierarquia_comercial)
        let menu = [
          {
            icon: 'mdi-account-plus-outline',
            ...this.menuRoute('cadastro'),
            click: isUserHierarquia
              ? () => {
                this.entrarFluxoVendasHierarquiaComercial('cadastro')
              }
              : undefined,
            analyticsEventName: 'menu_iniciarCadastro',
            blocked: false
          },
          {
            icon: 'mdi-cart-outline',
            ...this.menuRoute('iniciar-venda'),
            click: isUserHierarquia
              ? () => {
                this.entrarFluxoVendasHierarquiaComercial('iniciar-venda')
              }
              : undefined,
            analyticsEventName: 'menu_iniciarVenda',
            blocked: false
          },
          {
            icon: 'mdi-file-document-outline',
            ...this.menuRoute('minhas-vendas'),
            analyticsEventName: 'menu_minhasVendas',
            blocked: false
          },
          {
            icon: 'mdi-lock-outline',
            ...this.menuRoute('reservas'),
            click: isUserHierarquia
              ? () => {
                this.entrarFluxoVendasHierarquiaComercial('reservas')
              }
              : undefined,
            analyticsEventName: 'menu_reservas',
            blocked: false
          }
        ]
        if (this.exibe_politica_vendas) {
          menu.splice(2, 0, {
            icon: 'mdi-table-of-contents',
            ...this.menuRoute('politica-vendas'),
            click: isUserHierarquia
              ? () => {
                this.entrarFluxoVendasHierarquiaComercial('politica-vendas')
              }
              : undefined,
            analyticsEventName: 'menu_politicaDeVendas',
            blocked: false
          })
        }
        if (this.admin) {
          // menu.push({ Caso precise de itens no menu apenas para o admin })
        }
        menu.push({
          icon: 'rod-sair',
          ...this.menuRoute('logout'),
          click: this.logout,
          blocked: false
        })
        return menu.filter(function (value) {
          return !(process.env.NODE_ENV === 'production' && value.icon === 'rod-sair')
        })
      },
      itemHieraquiaSession: function () {
        this.verificarIntegridadeHierarquia(this.hierarquia_comercial)
        let itemHieraquiaSession = []

        if (!existHierarchy(this.hierarquia_comercial) && (this.comissionados.length > 0 || this.vendas_backoffice)) {
          itemHieraquiaSession = [
            {
              icon: 'mdi-office-building-outline',
              name: this.$session.get('nm_ponto_venda') || 'Carregando...',
              label: 'PV',
              value: this.$session.get('cd_ponto_venda'),
              isClickable: false
            },
            {
              icon: 'mdi-wallet-travel',
              name: this.nome_comissionado || 'Carregando...',
              label: 'Comissionado',
              value: this.codigo_comissionado,
              isClickable: this.comissionados.length > 1 && this.desativar_selecao_comissionado === false,
              click: this.clickComissionadoMenu
            }
          ]
        } else if (existHierarchy(this.hierarquia_comercial)) {
          const selectedGN = this.hierarquia_comercial.gerenteNegocioSelecionado
          const selectedEstrutura = this.hierarquia_comercial?.estruturaComercialSelecionada?.codigoEstruturaComercialCompleta
          const helperHierarquia = selectedGN.unicaEstruturaComercial
            ? {
              icon: 'mdi-help-box',
              text: 'Não é possível selecionar a estrutura comercial quando há somente uma disponível para o GN selecionado'
            }
            : null
          if (this.hierarquia_comercial.id === CommercialHierarchyTypes.RC.code) {
            itemHieraquiaSession = [
              {
                icon: 'mdi-crown',
                name: this.hierarquia_comercial.nomePessoa || '(Sem RC Definido)',
                label: 'RC',
                value: this.hierarquia_comercial.codigo,
                isClickable: false
              },
              {
                icon: 'mdi-account-tie',
                name: selectedGN.nomeComissionado || '(Sem GN Definido)',
                label: 'GN',
                value: selectedGN.codigoComissionado,
                isClickable: true,
                click: this.clickGnMenu
              },
              {
                icon: 'mdi-map',
                helper: helperHierarquia,
                name: this.getNameEstruturaComercial(),
                label: 'Estrutura',
                value: this.getCodigoEstruturaComercial(),
                isClickable: !selectedGN.unicaEstruturaComercial,
                click: this.clickHierarquiaComercial
              },
              {
                icon: 'mdi-office-building-outline',
                helper: {
                  icon: 'mdi-help-box',
                  text: 'Selecione uma Estrutura Comercial e em seguida um PV'
                },
                name: this.getNameSalePointHierarchy(),
                label: 'PV',
                value: this.getCdSalePointHierarchy(),
                isClickable: this.pontosReais.length > 1 && !!selectedEstrutura,
                click: this.clickSalesPointMenu
              },
              {
                icon: 'mdi-wallet-travel',
                helper: {
                  icon: 'mdi-help-box',
                  text: 'Selecione um PV e em seguida um Comissionado'
                },
                name: this.getNameComissionedHierarchy(),
                label: 'Comissionado',
                value: this.getCdComissionedHierarchy(),
                isClickable: [...new Set(this.comissionados.map(c => c.idComissionado))].length > 1,
                click: this.clickGetCommissionadoHierarchy
              }
            ]
          } else {
            itemHieraquiaSession = [
              {
                icon: 'mdi-account-tie',
                name: selectedGN.nomeComissionado || '(Sem GN Definido)',
                label: 'GN',
                value: selectedGN.codigoComissionado,
                isClickable: false,
                click: this.clickGnMenu
              },
              {
                icon: 'mdi-map',
                helper: helperHierarquia,
                name: this.getNameEstruturaComercial(),
                label: 'Estrutura',
                value: this.getCodigoEstruturaComercial(),
                isClickable: !selectedGN.unicaEstruturaComercial,
                click: this.clickHierarquiaComercial
              },
              {
                icon: 'mdi-office-building-outline',
                helper: {
                  icon: 'mdi-help-box',
                  text: 'Selecione uma Estrutura Comercial e em seguida um PV'
                },
                name: this.getNameSalePointHierarchy(),
                label: 'PV',
                value: this.getCdSalePointHierarchy(),
                isClickable: this.pontosReais.length > 1 && !!selectedEstrutura,
                click: this.clickSalesPointMenu
              },
              {
                icon: 'mdi-wallet-travel',
                helper: {
                  icon: 'mdi-help-box',
                  text: 'Selecione um PV e em seguida um Comissionado'
                },
                name: this.getNameComissionedHierarchy(),
                label: 'Comissionado',
                value: this.getCdComissionedHierarchy(),
                isClickable: [...new Set(this.comissionados.map(c => c.idComissionado))].length > 1,
                click: this.clickGetCommissionadoHierarchy
              }
            ]
          }
          if (this.verifyIfLoginIsCommercialHierarchyAssistent(this.hierarquia_comercial)) {
            itemHieraquiaSession.unshift({
              icon: 'mdi-headset',
              name: this.hierarquia_comercial.nome_assistente,
              label: this.hierarquia_comercial.tipo_assistente,
              value: this.hierarquia_comercial.codigo_assistente,
              isClickable: false
            })
          }
        }
        return itemHieraquiaSession
      }
    },
    watch: {
      flavor: {
        handler: async function (newValue) {
          if (newValue === this.flavorExibicao.flavor || !newValue) {
            return
          }
          if (newValue === Flavors.ED) {
            this.flavorExibicao.flavor = Flavors.ED
            this.flavorExibicao.nomeExibicao = 'Escritório Digital'
            return
          }
          try {
            this.carregandoNomeFlavor = true
            const consultaFlavor = await this.$http.get(`/flavor_by_name/${newValue}`).then(response => response.data)
            if (this.flavor === Flavors.ED) {
              this.flavorExibicao.flavor = Flavors.ED
              this.flavorExibicao.nomeExibicao = 'Escritório Digital'
              return
            }
            if (consultaFlavor) {
              this.flavorExibicao.flavor = consultaFlavor.flavor
              this.flavorExibicao.nomeExibicao = consultaFlavor.nome_exibicao
              if (this.$session.get('exibe_reenvio_whatsapp') !== 1 || consultaFlavor.exibe_reenvio_whatsapp !== true) {
                if (consultaFlavor.exibe_reenvio_whatsapp !== undefined && consultaFlavor.exibe_reenvio_whatsapp !== null) {
                  this.$session.set('exibe_reenvio_whatsapp', consultaFlavor.exibe_reenvio_whatsapp)
                }
              }
            }
          } catch (err) {
            return
          } finally {
            this.carregandoNomeFlavor = false
          }
        },
        immediate: true
      },
      id_empresa () {
        if (this.is_usuario_logado_hierarquia) {
          return
        }
        this.setPermissaoVendaTodosProdutos()
        this.goHome()
      },
      id_comissionado_venda () {
        if (this.is_usuario_logado_hierarquia) {
          return
        }
        this.setPermissaoVendaTodosProdutos()
        this.goHome()
      },
      id_unidade_negocio () {
        if (this.is_usuario_logado_hierarquia) {
          return
        }
        this.setPermissaoVendaTodosProdutos()
        this.goHome()
      },
      modal_hierarquia_estrutura_entrando_venda (valor) {
        if (valor) {
          this.dialogEstruturaComercial = valor
        }
      },
      modal_hierarquia_ponto_venda_entrando_venda (valor) {
        if (valor) {
          this.dialogSalesPointHierarchyVisible = valor
        }
      },
      modal_hierarquia_comissionado_entrando_venda (valor) {
        if (valor) {
          this.dialogComissionedHierarchyVisible = valor
        }
      },
      sinalMudarIdentidadeVisual (valor) {
        if (!valor) {
          return
        }
        loadFlavor(this.$session.get('flavor'))
        this.logo = flavorRes('img/logo-menu.png')
        this.$session.set('sinalMudarIdentidadeVisual', false)
      }
    },
    async created () {
      if (this.is_usuario_logado_hierarquia) {
        try {
          this.pontosVenda = await this.carregarPontosVenda()
        } catch (error) {
          console.error('Erro ao carregar pontos de venda:', error)
          this.pontosVenda = []
        }
      }
    },
    mounted () {
      const isTrocaAmbiente = this.$session.get('trocando_ambiente')

      if (isTrocaAmbiente) {
        this.$session.set('ambiente', false)
      }

      if (!this.is_usuario_logado_hierarquia) {
        this.verificarIdPessoaUsuarioLogadoNewcon()
      } else {
        this.verificarIntegridadeHierarquia(this.hierarquia_comercial)
        this.resetarEstruturaComercial()
        this.resetarFlavor()
        this.resetarUnidadeNegocio()
        loadFlavor(Flavors.ED)
        this.logo = flavorRes('img/logo-menu.svg')
      }

      let carregarElseBackOffice = true
      this.loadConfiguracoes()
      //  Verifica se a sessão está vindo do painel adiminstrativo, caso esteja vindo do painel, checa se é um usuário Backoffice,
      if (this.$session.get('sessao_painel')) {
        const _l = this.$session.get('_l')
        const _s = this.$session.get('_s')

        this.$session.destroy()

        this.$router.replace({
          name: 'login',
          params: { login: _l, sessao_painel: true, _s: _s }
        })
        if (this.$session.get('vendas_backoffice')) {
          this.definirFlavorBackoffice()
          if (typeof this.$session.get('id_comissionado_venda') !== 'undefined' && this.$session.get('id_comissionado_venda') > 0) {
            this.exibir_autocomplete_comissionados = false
          }
        } else {
          this.$router.replace({ name: 'logout' })
        }
      } else {
        if (this.$session.get('ambiente') && !this.$session.get('vendas_backoffice')) {
          this.alteraUnidadeParaSSO(this.$session.get('ambiente'))
          this.loadComissionados(this.id_empresa)
          carregarElseBackOffice = false
        }
        if (this.$session.get('vendas_backoffice')) {
          this.definirFlavorBackoffice()
          if (typeof this.$session.get('id_comissionado_venda') !== 'undefined' && this.$session.get('id_comissionado_venda') > 0) {
            this.exibir_autocomplete_comissionados = false
          }
        } else if (carregarElseBackOffice) {
          this.loadComissionados(this.id_empresa)
          if (isTrocaAmbiente) {
            this.alteraUnidadeParaTrocaAmbiente()
          } else {
            this.alterarUnidade(this.id_unidade_negocio, this.id_empresa)
          }
        }

        this.is_tribanco = this.$session.get('flavor') === 'tribanco'
        this.id_tribanco = this.$session.get('identificador_representante_tribanco')
      }
      if (this.nome_comissionado === '' && this.codigo_comissionado === '' && this.$session.get('id_comissionado_venda') > 0) {
        const comissionado = this.comissionados.filter(com => com.id_comissionado === this.$session.get('id_comissionado_venda') || com.ID_Comissionado === this.$session.get('id_comissionado_venda'))
        this.codigo_comissionado = comissionado[0]['cd_comissionado']
        this.nome_comissionado = comissionado[0]['nm_pessoa']
      }
    },
    methods: {
      ...mapMutations(['setJornadaVenda']),
      warnSemComissionadosSelecionados () {
        notification(AlertTypes.ERROR, 'Nenhum comissionado foi selecionado.')
      },
      async setPermissaoVendaTodosProdutos () {
        const requestPermissao = await this.$http.get(`/flavor-permite-todos-produtos/${this.$session.get('flavor')}`).catch(() => {
          return { data: { permiti_todos_produtos: false } }
        })
        this.$session.set('permite_venda_todos_produtos', requestPermissao.data.permiti_todos_produtos)
      },
      getGerenteNegocioSelecionado () {
        if (!existHierarchy(this.hierarquia_comercial)) {
          return ''
        } else {
          return this.hierarquia_comercial.gerenteNegocioSelecionado.codigoUsuario
        }
      },
      getEstruturaDoGNSelecionado () {
        if (!existHierarchy(this.hierarquia_comercial)) {
          return ''
        } else {
          return String(this.hierarquia_comercial.gerenteNegocioSelecionado.idEstruturaComercial)
        }
      },
      getEstruturaComercialSelecionado () {
        if (!existHierarchy(this.hierarquia_comercial)) {
          return ''
        } else {
          return this.hierarquia_comercial?.estruturaComercialSelecionada?.idEstruturaComercial || 0
        }
      },
      async verificarIdPessoaUsuarioLogadoNewcon () {
        if (!this.$session.get('dados_usuario_logado').id_pessoa_newcon) {
          await this.$http
            .post('/usuarios/verifica-id-pessoa-newcon', {
              id_usuario_erp: this.$session.get('id_usuario'),
              options: {
                silent: true
              }
            })
            .then(async response => {
              if (!this.$session.get('dados_usuario_logado').id_pessoa_newcon) {
                const id_pessoa_newcon = response.data
                const dados_usuario = await this.trazerDadosUsuarioLogadoNewcon(
                  id_pessoa_newcon
                )

                if (dados_usuario && dados_usuario.enderecos_pessoa && dados_usuario.enderecos_pessoa.length > 99) {
                  notification(
                    AlertTypes.ERROR, 'Foi atingida a capacidade máxima de endereços cadastrados! Entre em contato com a Área de Suporte para ajustar o seu login.', false, false, true, true
                  )
                }

                this.$session.set('dados_usuario_logado', {
                  id_pessoa_newcon: id_pessoa_newcon,
                  enderecos_pessoa: dados_usuario.enderecos_pessoa,
                  telefones_pessoa: dados_usuario.telefones_pessoa,
                  email_pessoa: dados_usuario.email_pessoa

                })
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      },
      async trazerDadosUsuarioLogadoNewcon (id_pessoa_newcon) {
        // eslint-disable-next-line no-return-await
        return await this.$http
          .get(`/usuarios/dados-pessoa/${id_pessoa_newcon}`, {
            options: { silent: true }
          })
          .then(response => {
            return response.data
          })
          .catch(() => {
            // Não é para exibir em tela o erro.
          })
      },
      goHome () {
        if (!['minhas-vendas', 'reservas'].includes(this.$route.name)) {
          try {
            this.$router.replace('/')
          } catch (e) {
            return false
          }
        }
      },
      menuRoute (name) {
        try {
          const route = this.$router.resolve({ name }).route
          const selected = this.$route.path.startsWith(route.path)
          return route.matched.length ? { text: route.meta.title, to: route.path, selected } : { text: '// fixme' }
        } catch (e) {
          return false
        }
      },
      logout () {
        alert({
          text: 'Tem certeza que deseja sair do sistema?',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => this.$router.replace({ name: 'logout' })
          }
        })
        return false
      },
      acessar (item) {
        if (item.click) {
          item.click()
        } else {
          try {
            sendAnalyticsEvent(this.$gtag, item.analyticsEventName)
            this.defineSaleJourney(item.to)
            this.$router.push(item.to)
          } catch (e) {
            return false
          }
        }
      },
      defineSaleJourney (to) {
        if (to === '/cadastro') {
          this.setJornadaVenda('jornada_cadastro')
        }

        if (to === '/iniciar-venda') {
          this.setJornadaVenda('jornada_venda')
        }

        if (to === '/politica-vendas') {
          this.setJornadaVenda('jornada_politica_venda')
        }
      },
      async definirFlavorBackoffice () {
        this.loadComissionadosBaseLocal()
        if (typeof this.$session.get('flavor') === 'undefined' || this.$session.get('flavor') === null || this.$session.get('flavor') === '' || this.$session.get('login_sso')) {
          const currentUrl = window.location.hostname
          this.$http
            .get(`/flavor/${currentUrl}`)
            .then(response => {
              if (typeof response.data.nm_flavor !== 'undefined' && response.data.nm_flavor !== '') {
                this.$session.set('flavor', response.data.nm_flavor)
                loadFlavor(response.data.nm_flavor)
                this.logo = flavorRes('img/logo-menu.png')
                this.loadEmpresaVendaBackoffice()
              }
            })
            .catch(() => {
              this.errAutenticacao('Não foi possível carregar a identidade visual.')
            })
        } else {
          loadFlavor(this.$session.get('flavor'))
          this.logo = flavorRes('img/logo-menu.png')
        }
      },
      loadComissionadosBaseLocal () {
        this.$http
          .get(`/comissionados`)
          .then(response => {
            if (response.data) {
              this.comissionados_base_local = response.data
            }
          })
          .catch(() => {
            this.errComissionados('Não foi possível carregar os comissionados.')
          })
      },
      alterarEmpresa (id_empresa) {
        this.$session.set('id_empresa', id_empresa)
        this.loadComissionados(id_empresa)
      },
      loadEmpresaVendaBackoffice (editar = false) {
        let empresas_permitidas_flavor = []
        this.$http
          .get(`/flavor_empresas_permitidas/${this.$session.get('flavor')}`)
          .then(r => {
            if (!r.data) {
              this.errAutenticacao('Não foi possível carregar as empresas permitidas, tente novamente mais tarde.')
            } else {
              empresas_permitidas_flavor = r.data.empresas_permitidas.map(Number)
              this.flavors_config = r.data
              let empresas_disponiveis = []
              let empresas_usuario = []
              this.empresas.forEach(empresa => {
                empresas_usuario.push(empresa['ID_Empresa'])
                if (empresas_permitidas_flavor.includes(empresa['ID_Empresa'])) {
                  empresas_disponiveis.push(empresa)
                }
              })
              if (empresas_disponiveis.length <= 0) {
                return this.errAutenticacao(`Nenhuma das empresas vinculadas a este ambiente podem ser acessadas pelo seu usuário! Empresas vinculadas para a identidade visual do ambiente ${this.flavors_config.nome_amigavel_flavor.nome_amigavel}  ( ${this.flavors_config.empresas_permitidas} ). Empresas permitidas para o seu usuário ( ${empresas_usuario} )`)
              }

              this.$session.set('empresas', empresas_disponiveis)
              if (this.$session.get('id_empresa') === 0 || this.$session.get('id_empresa') === null || editar || this.$session.get('login_sso')) {
                if (this.empresas.length > 1) {
                  this.dialog_empresas = true
                } else {
                  this.escolherEmpresaVendaBackoffice(this.empresas[0])
                }
              }
            }
          })
          .catch(() => {
            this.errAutenticacao('Não foi possível carregar as empresas permitidas, tente novamente mais tarde.')
          })
      },
      escolherEmpresaVendaBackoffice (empresa) {
        this.$session.set('id_empresa', empresa['ID_Empresa'])
        const filiais = this.$session.get('filiais')
        if (filiais) {
          this.$session.set('filial', filiais.find(filial => filial.ID_Empresa === empresa.ID_Empresa))
        }
        this.dialog_empresas = false
        this.exibir_autocomplete_comissionados = true
      },
      escolherPontoVenda (ponto_venda) {
        if (this.$session.get('vendas_backoffice')) {
          this.escolherPontoVendaBackoffice(ponto_venda)
        } else {
          this.$session.set('id_ponto_venda', ponto_venda['ID_Ponto_Venda'])
          this.$session.set('cd_ponto_venda', ponto_venda['CD_Ponto_Venda'])
          this.$session.set('nm_ponto_venda', ponto_venda['NM_Ponto_Venda'])
          if (ponto_venda['Unidade_Negocio']) {
            const pontoDeVendaJaExiste = !!this.unidades.find(ponto_de_venda_sessao => {
              return JSON.stringify(ponto_de_venda_sessao) === JSON.stringify(ponto_venda['Unidade_Negocio'])
            })
            if (!pontoDeVendaJaExiste) {
              this.unidades.push(ponto_venda['Unidade_Negocio'])
            }
          }
        }
        this.dialog_pontos_venda = false
      },
      escolherPontoVendaBackoffice (ponto_venda) {
        this.$session.set('id_ponto_venda', ponto_venda['ID_Ponto_Venda'])
        this.$session.set('cd_ponto_venda', ponto_venda['CD_Ponto_Venda'])
        this.$session.set('nm_ponto_venda', ponto_venda['NM_Ponto_Venda'])
        if (ponto_venda['Unidade_Negocio']) {
          this.unidades.push(ponto_venda['Unidade_Negocio'])
        }
        this.alterarUnidade(ponto_venda['ID_Unidade_Negocio'], this.id_empresa)
        this.dialog_pontos_venda = false
      },
      alterarUnidade (id_unidade_negocio, id_empresa) {
        this.$session.set('id_unidade_negocio', id_unidade_negocio)
        const unidade = this.unidades.find(unidade => unidade.id_unidade_negocio === id_unidade_negocio && unidade.id_empresa === id_empresa)
        if (unidade) {
          if (this.$session.get('vendas_backoffice')) {
            let ok = false
            this.flavors_config.todos_flavors.forEach(flavor => {
              if (flavor.nm_flavor === unidade.flavor) {
                ok = true
              }
            })
            if (ok) {
              this.$session.set('flavor', unidade.flavor)
              loadFlavor(unidade.flavor)
            } else {
              this.$session.set('flavor', this.flavors_config.flavor_padrao.nm_flavor)
              loadFlavor(this.flavors_config.flavor_padrao.nm_flavor)
            }
          } else {
            this.$session.set('flavor', unidade.flavor)
            loadFlavor(unidade.flavor)
          }
        } else if (!existHierarchy(this.hierarquia_comercial)) {
          this.$session.set('flavor', this.flavors_config.flavor_padrao.nm_flavor)
          loadFlavor(this.flavors_config.flavor_padrao.nm_flavor)
        }
        this.logo = flavorRes('img/logo-menu.png')
      },
      alteraUnidadeParaSSO (unidade_negocio) {
        this.$session.set('flavor', unidade_negocio.nm_flavor)
        loadFlavor(unidade_negocio.nm_flavor)
        this.logo = flavorRes('img/logo-menu.png')
      },
      alteraUnidadeParaTrocaAmbiente () {
        loadFlavor(this.$session.get('flavor'))
        this.logo = flavorRes('img/logo-menu.png')
      },
      async alterarComissionado (comissionado, selecaoComissionado = false) {
        if (selecaoComissionado) {
          comissionado = this.comissionados.find(com => com.ID_Comissionado === this.id_comissionado_usuario_comum_autocomplete)
          if (!comissionado) {
            this.warnSemComissionadosSelecionados()
            return
          }
        }
        this.codigo_comissionado = comissionado['CD_Comissionado']
        this.nome_comissionado = comissionado['NM_Pessoa']

        this.$session.set('id_comissionado_venda', comissionado.ID_Comissionado)

        this.dialog_comissionados = false
        await this.loadPontosVenda(comissionado.ID_Comissionado)
      },
      async escolherComissionadoBackoffice () {
        if (!this.id_comissionado_autocomplete) {
          this.warnSemComissionadosSelecionados()
          return
        }

        const permite_venda = await this.checkComissionadoIsAbleToSell(this.id_comissionado_autocomplete)
        if (!permite_venda) {
          return
        }
        this.$session.set('id_comissionado_venda', this.id_comissionado_autocomplete)

        const comissionados = []
        if (this.id_comissionado) {
          comissionados.push(this.id_comissionado)
        }
        if (this.id_comissionado_autocomplete) {
          comissionados.push(this.id_comissionado_autocomplete)
        }
        this.setComissionadosBackoffice(comissionados)
          .then(() => {
            const comissionado = this.comissionados.filter(com => com.id_comissionado === this.id_comissionado_autocomplete)
            this.codigo_comissionado = comissionado[0]['cd_comissionado']
            this.nome_comissionado = comissionado[0]['nm_pessoa']

            this.exibir_autocomplete_comissionados = false
            this.loadPontosVendaBackOffice(this.id_comissionado_autocomplete)
          })
          .catch(this.errComissionados)
      },
      async checkComissionadoIsAbleToSell (selected_comissioned) {
        return this.$http
          .get(`/comissionado/checar_permite_venda/${selected_comissioned}`)
          .then(response => {
            if (!response.data.ok) {
              notification('warning', 'O comissionado selecionado não está disponível para venda! Favor selecionar outro comissionado.')
            }

            return response.data.ok
          })
          .catch(() => {
            notification('error', 'Ocorreu um erro ao checar o comissionado, tente novamente em instantes, se persistir contate a administradora')
          })
      },
      descricaoComissionadosBackOffice (item) {
        return `${item['cd_comissionado']} - ${item['nm_pessoa']}`
      },
      descricaoComissionados (item) {
        return `${item['CD_Comissionado']} - ${item['NM_Pessoa']}`
      },
      async loadPontosVendaBackOffice (id_comissionado) {
        await this.$http
          .get(`/comissionado/ponto_venda/${this.id_empresa}/${id_comissionado}`)
          .then(r => {
            if (r.data === 0) {
              notification('warning', 'Comissionado não possui pontos de venda')
            } else {
              this.pontos_vendas = r.data
              if (this.pontos_vendas.length > 1) {
                this.dialog_pontos_venda = true
              } else {
                this.escolherPontoVendaBackoffice(this.pontos_vendas[0])
              }
            }
          })
          .catch(() => this.errAutenticacao('Não foi possível carregar os pontos de venda!'))
      },
      async loadPontosVenda (id_comissionado) {
        await this.$http
          .get(`/comissionado/ponto_venda/${this.id_empresa}/${id_comissionado}`)
          .then(r => {
            if (r.data === 0) {
              notification('warning', 'Comissionado não possui pontos de venda')
            } else {
              this.pontos_vendas = r.data
              if (this.pontos_vendas.length > 1) {
                this.dialog_pontos_venda = true
              } else {
                this.escolherPontoVenda(this.pontos_vendas[0])
              }
            }
          })
          .catch(() => this.errAutenticacao('Não foi possível carregar os pontos de venda!'))
      },
      loadConfiguracoes () {
        this.$http.get('/usuarios/configuracoes', { options: { silent: true } }).then(res => {
          this.$session.set('configuracoes', res.data)
        })
      },
      async loadComissionados (id_empresa) {
        if (existHierarchy(this.hierarquia_comercial)) {
          return
        }

        const id_comissionado = this.id_comissionado
        const id_unidade_negocio = this.id_unidade_negocio
        await this.$http
          .get(`/usuarios/comissionados`, {
            params: {
              id_unidade_negocio,
              ID_Comissionado: id_comissionado,
              ID_Empresa: id_empresa
            }
          })
          .then(async r => {
            let comissionado_principal = null

            const comissionados = r.data.comissionados
            const funcionalidade_unidade_principal_ativa_e_retornou_newcon = r.data.unidade_principal_ativa_e_retornou_newcon
            if (funcionalidade_unidade_principal_ativa_e_retornou_newcon) {
              comissionado_principal = comissionados.find(c => c.ID_Comissionado === id_comissionado)
            }
            const selecionado = comissionados.find(c => c.ID_Comissionado === this.id_comissionado_venda)
            if (selecionado) {
              await this.alterarComissionado(selecionado)
            } else if (comissionados.length === 1) {
              await this.alterarComissionado(comissionados[0])
            } else if (funcionalidade_unidade_principal_ativa_e_retornou_newcon) {
              await this.alterarComissionado(comissionado_principal)
              this.$store.commit('setDesativarSelecaoComissionado', true)
            } else if (comissionados.length > 1) {
              this.dialog_comissionados = true
            } else {
              notification(AlertTypes.WARN, 'Nenhum comissionado encontrado')
            }

            this.$session.set('comissionados', comissionados)
          })
          .catch(this.errComissionados)
      },
      abrirSincronizacaoDialog () {
        this.dialog_sincronizacao = true
      },
      errComissionados () {
        if (mensagemUsuarioBloqueado.USER_BLOCKED) {
          return
        }
        alert({
          text: 'Não foi possível carregar os comissionados.',
          buttons: {
            Fechar: () => this.$router.replace({ name: 'logout' })
          }
        })
      },
      errAutenticacao (msg) {
        alert({
          text: msg,
          buttons: {
            Fechar: () => this.$router.replace({ name: 'logout' })
          }
        })
      },
      clickComissionadoMenu () {
        this.vendas_backoffice ? this.loadEmpresaVendaBackoffice(true) : (this.dialog_comissionados = true)
      },
      clickGnMenu () {
        this.dialogCommercialHierarchyVisible = true
      },
      clickGetCommissionadoHierarchy () {
        const comissionados = this.$session.get('comissionados') || []

        if (this.$session.get('id_ponto_venda') > 0) {
          const idsUnicos = [...new Set(comissionados.map(c => c.idComissionado))]

          if (idsUnicos.length > 1) {
            this.dialogComissionedHierarchyVisible = true
          }
        } else {
          notification('warning', 'Por favor, selecione primeiro um Ponto de Venda para em seguida selecionar um Comissionado!')
        }
      },
      clickSalesPointMenu () {
        if (this.validarPontosDeVenda()) {
          this.dialogSalesPointHierarchyVisible = true
        }
      },
      clickHierarquiaComercial () {
        this.dialogEstruturaComercial = true
      },
      atualizarPontosVenda (pontosVenda) {
        this.pontosVenda = pontosVenda
        this.pontosVendaCarregados = true

        const realPVs = pontosVenda.filter(pv => String(pv.idPontoVenda) !== 'todos')
        const idPV = this.$session.get('id_ponto_venda')

        const pvSelecionado = pontosVenda.find(pv => String(pv.idPontoVenda) === String(idPV))

        if (pvSelecionado) {
          this.selecionarPontoVenda(pvSelecionado)
        } else if (realPVs.length === 1) {
          this.selecionarPontoVenda(realPVs[0])
        } else {
          this.$session.set('id_ponto_venda', '')
          this.$session.set('cd_ponto_venda', '')
          this.$session.set('nm_ponto_venda', '')
          this.$session.set('comissionados', [])
          this.$session.set('id_comissionado_venda', '')
        }
      },
      selecionarPontoVenda (pv) {
        if (!this.pontosVenda.some(p => String(p.idPontoVenda) === String(pv.idPontoVenda))) {
          this.pontosVenda.push(pv)
        }

        this.$session.set('id_ponto_venda', pv.idPontoVenda)
        this.$session.set('cd_ponto_venda', pv.codigoPontoVenda)
        this.$session.set('nm_ponto_venda', pv.nomeExibicaoPontoVenda)
        this.$session.set('data_inicio_vigencia', pv.dataInicioVigencia)
        this.$session.set('data_fim_vigencia', pv.dataFimVigencia)
        this.$session.set('comissionados', pv.comissionados || [])

        const comissionados = pv.comissionados || []
        const ids = comissionados.map(c => c.idComissionado)
        const unico = ids.length > 0 && ids.every(id => id === ids[0])
        this.$session.set('id_comissionado_venda', unico ? ids[0] : -1)
      },
      getNameSalePointHierarchy () {
        const nmPontoVenda = this.$session.get('nm_ponto_venda')
        if (nmPontoVenda) {
          return nmPontoVenda
        }

        if (this.nm_ponto_venda) {
          return this.nm_ponto_venda
        }

        if (this.pontosVenda.length === 0) return '(Sem PV Definido)'
        if (this.pontosVenda.length === 1 && String(this.pontosVenda[0].idPontoVenda) === 'todos') return '(Sem PV Definido)'

        const idPV = this.$session.get('id_ponto_venda')
        const pvSelecionado = this.pontosVenda.find(pv => String(pv.idPontoVenda) === String(idPV))

        return pvSelecionado
          ? pvSelecionado.nomeExibicaoPontoVenda
          : CommercialHierarchyTypes.Todos.text
      },
      getCdSalePointHierarchy () {
        const cdPontoVenda = this.$session.get('cd_ponto_venda')
        if (cdPontoVenda) {
          return cdPontoVenda
        }

        if (this.cd_ponto_venda) {
          return this.cd_ponto_venda
        }

        if (!this.pontosVendaCarregados) return ''
        if (this.pontosVenda.length === 0) return ''
        if (this.pontosVenda.length === 1 && String(this.pontosVenda[0].idPontoVenda) === 'todos') return ''

        const idPV = this.$session.get('id_ponto_venda')
        const pvSelecionado = this.pontosVenda.find(pv => String(pv.idPontoVenda) === String(idPV))

        return pvSelecionado
          ? pvSelecionado.codigoPontoVenda
          : CommercialHierarchyTypes.Todos.text
      },
      getNameEstruturaComercial () {
        return this.hierarquia_comercial?.estruturaComercialSelecionada ? this.hierarquia_comercial.estruturaComercialSelecionada.nomeEstruturaComercial : CommercialHierarchyTypes.Todos.text
      },
      getCodigoEstruturaComercial () {
        return this.hierarquia_comercial?.estruturaComercialSelecionada ? this.hierarquia_comercial.estruturaComercialSelecionada.codigoEstruturaComercialCompleta : CommercialHierarchyTypes.Todos.text
      },
      getNameComissionedHierarchy () {
        if (this.getNameSalePointHierarchy() === '(Sem PV Definido)') {
          return '(Sem Comissionado Definido)'
        }
        if (this.id_comissionado_venda > 0) {
          const selectedComissioned = this.comissionados.find(comissioned => comissioned.idComissionado === this.id_comissionado_venda)
          return selectedComissioned.nomeComissionado
        }

        return CommercialHierarchyTypes.Todos.text
      },
      getCdComissionedHierarchy () {
        if (this.getNameSalePointHierarchy() === '(Sem PV Definido)') {
          return ''
        }
        if (this.id_comissionado_venda > 0) {
          const selectedComissioned = this.comissionados.find(comissioned => comissioned.idComissionado === this.id_comissionado_venda)
          return selectedComissioned.codigoComissionado
        }

        return CommercialHierarchyTypes.Todos.text
      }
    }
  }
</script>

<style lang="scss">
.clickable {
    color: var(--accent); /* Define a cor do texto como azul */
    text-decoration: underline; /* Adiciona um sublinhado para indicar que é um link */
    cursor: pointer; /* Altera o cursor para parecer um link */
}

.clickable:hover {
    color: var(--primary); /* Muda a cor do texto quando o mouse está sobre o link */
}
</style>
